import { emit } from '../eventBus';

export const updateDataMiddleware = async (response: Nullable<Response>): Promise<Nullable<Response>> => {
  if (response) {
    if (response.headers.has('App-Profile-Updated')) emit({ action: 'update_profile' });
    if (response.headers.has('App-Features-Updated')) emit({ action: 'update_features', force: true });
  }

  return response;
};
